import React from "react";
import { LeafIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { PRODUCT_IMAGE } from "../../data/content";
export function Hero() {
  return <header className="relative w-full bg-cream px-4 pb-14 pt-8 sm:pt-12" data-id="element-186" data-mp="cut9bvitdj3t">
      <div className="mx-auto max-w-5xl text-center" data-id="element-187" data-mp="hvh0ch71lzy1">
        <div className="inline-flex items-center gap-2.5" data-id="element-188" data-mp="hw8t7k999jkm">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-forest text-white" data-id="element-189" data-mp="mutu7lwc07a4">
            <LeafIcon className="h-5 w-5" aria-hidden="true" data-id="element-190" data-mp="qukklohy4le4" />
          </span>
          <span className="text-left font-serif text-lg font-bold leading-tight text-forest" data-id="element-191" data-mp="vlu92lrrdiof">
            Biomagnetism
            <br data-id="element-192" data-mp="10kdvena9kwhb" />
            <span className="font-sans text-[11px] font-bold uppercase tracking-[0.16em] text-gold" data-id="element-193" data-mp="10kxew8fkbsxg">Protocol Vault™</span>
          </span>
        </div>

        <h1 className="mx-auto mt-7 max-w-4xl font-serif text-[34px] font-bold leading-[1.1] text-ink sm:text-6xl" data-id="element-194" data-mp="1ajd2w2jamm2q">
          Stop Organizing Everything From Scratch. Follow a{" "}
          <em className="text-forest" data-id="element-195" data-mp="4optqa82e77t">Ready-Made 30-Day</em> Learning System.
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-muted sm:text-xl" data-id="element-196" data-mp="4r2ltg7jdxyl">
          A complete step-by-step educational system to organize your biomagnetism studies in 30 days — with{" "}
          <strong className="text-ink" data-id="element-197" data-mp="seanzp9o4qwe">six practical volumes</strong>, ready-to-use learning protocols, visual guides, and{" "}
          <strong className="text-ink" data-id="element-198" data-mp="nexqmal681fk">five exclusive bonuses</strong>.
        </p>

        <img src={PRODUCT_IMAGE} alt="Biomagnetism Protocol Vault: six volumes, five bonus collections, and printable study resources" className="mx-auto mt-6 w-full max-w-2xl" data-id="element-199" data-mp="io92944sfkkn" />

        <div className="mt-4" data-id="element-200" data-mp="1b51sodipnt4g">
          <CtaButton id="first-cta" label="Yes! I want the complete Protocol Vault" showMicrocopy data-id="element-201" data-mp="1b6d14qn3pp1w" />
        </div>

        <Countdown data-id="element-202" data-mp="16bz0a8po6ppu" />
      </div>
    </header>;
}